// src/api/tournamentApi.js
import axios from 'axios';
import { format } from 'date-fns';
import { axiosInstance } from '../interceptor';

const API_URL = `${process.env.REACT_APP_API_URL}custom`
// `${process.env.REACT_APP_API_URL}custom`;



export const createTournament = async (tournamentData, token) => {
  const formattedStartTime = format(tournamentData.startTime, 'yyyy-MM-dd HH:mm:ss');

  try {
    const response = await axiosInstance.post(
      `${API_URL}/create_tournament`,
      {
        name: tournamentData.name,
        status: tournamentData.status,
        state: tournamentData.state || 'Scheduled',
        start_time: formattedStartTime,
        description: tournamentData.description,
        participation_fee_currency: tournamentData.participationFeeCurrency,
        tournament_duration: tournamentData.tournamentDuration,
        format: tournamentData.format,
        trigger_time: formattedStartTime,
        participation_fee: tournamentData.participationFee,
        min_prize_money: tournamentData.minPrizeMoney,
        tnc: tournamentData.tnc,
        match_duration: tournamentData.matchDuration,
        min_participants: tournamentData.minParticipants,
        max_participants: tournamentData.maxParticipants,
        number_of_rounds: tournamentData.numberOfRounds,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error creating tournament:', error);
    throw error;
  }
};

export const fetchUpcomingTournaments = async (page = 1, itemsPerPage = 50) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/upcomingTournaments`,
      {
        params: {
          sort_by: 'start_time',
          items_per_page: itemsPerPage,
          state: 'Scheduled,In-Progress',
          page,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching tournaments:', error);
    throw error;
  }
};




export const updateTournament = async (tournamentData, tournamentId, token) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/update_tournament/${tournamentId}`, tournamentData,
      //   {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //   },
      // }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadTournamentFile = async (formData) => {
  const response = await axiosInstance.post(`${API_URL}/tournaments/file_upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })


  return response

}


export const updateTournamentBooking = async (tournamentId, tournamentData) => {
  console.log(tournamentId, "tournamentId")
  try {
    const response = await axiosInstance.patch(`${API_URL}/tournaments/update/${tournamentId}`, tournamentData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

